/* eslint-disable no-param-reassign */
const getCoveragePackageLevel = (submission) => {
    if (!submission.bindData?.value?.chosenQuote) {
        return undefined
    }

    const chosenQuote = submission.quoteData.value.offeredQuotes.find((offering) => {
        return offering.publicID === submission.bindData.value.chosenQuote
    });

    return chosenQuote.coveragePackageLevel_Ext;
}

const PUMBTrackEvent = (eventName, isSkipping, submissionVM, user, props, isQnB) => {
    try {
        if (eventName === 'Quote Step Submitted' || eventName === 'Issuance Step Submitted' ) {
            sessionStorage.setItem('userSubmitAction', true);
            sessionStorage.setItem('userSubmitted', new Date());
            if (!isSkipping && sessionStorage.getItem('pageLoaded')) {
                const pageLoadTime = new Date(sessionStorage.getItem('pageLoaded'));
                const userSubmitTime = new Date();
                props.user_spent_time = (userSubmitTime - pageLoadTime) / 1000;
                sessionStorage.setItem('lastAction', props.action);
            }
        }
        if (eventName === 'Quote Step Reached' || eventName === 'Issuance Step Reached' || eventName === 'Quote Purchased' ) {
            if (!isSkipping) {
                sessionStorage.setItem('pageLoaded', new Date());
                if (sessionStorage.getItem('userSubmitAction') && sessionStorage.getItem('userSubmitted')) {
                    const userSubmitTime = new Date(sessionStorage.getItem('userSubmitted'));
                    const pageLoadTime = new Date();
                    props.system_load_time = (pageLoadTime - userSubmitTime) / 1000;
                    sessionStorage.setItem('userSubmitAction', false);
                    sessionStorage.setItem('lastStep', props.step);
                }
            }
        }
        props.quote_type = sessionStorage.getItem('quoteType');
        props.pol_state = submissionVM.baseData.value.policyAddress.state;
        if (!isQnB) {
            props.user_type = user.userTypeName_ML;
            props.agent_id = user.userName_ML;
        }
        props.app_name = (isQnB) ? 'Quote and Buy' : 'Producer Engage';
        props.app_parent = 'Agent360';
        if (submissionVM.lobData.personalUmbrella.priorInsurance.value !== undefined)
        {
            if (submissionVM.lobData.personalUmbrella.priorInsurance.value[0].
                answers.MultLineCurrentInsuranceProvider_Ext != null) {
                props.prior_insurance_carrier = submissionVM.lobData.personalUmbrella.priorInsurance.value[0].
                    answers.MultLineCurrentInsuranceProvider_Ext.replace('MultLineCurrentInsuranceProvider','');
            }}
        props.isPFMReturned = submissionVM.baseData.isPFMReturned_ML.value;
        props.pfm_no_hit = submissionVM.baseData.pfmLevel_ML.value === ('NF'||'NK'||'NN'||'NQ') ? true : undefined ;
        props.gpc_code = submissionVM.baseData.value.gafInfo_ML !== undefined ? submissionVM.baseData.value.gafInfo_ML.gpcCode : undefined ;
        props.lob = 'Umbrella';
        props.isCompRater = submissionVM.hvqDiscrepancies_ML.value !== undefined ;
        props.quote_publicId = submissionVM.quotePublicId.value;
        props.quoteID = submissionVM.quoteID?.value;
        props.bundleIndicator = (submissionVM.isBundle_ML && submissionVM.isBundle_ML.value) ? 'Y': 'N';
        window.analytics.track(eventName, props);

        if (eventName === 'Quote Step Reached' || eventName === 'Issuance Step Reached' || eventName === 'Quote Purchased' ) {
            const pageProps = {
                state: props.pol_state,
                lob: props.lob,
                priorCarrier: (props.prior_insurance_carrier) ? props.prior_insurance_carrier : undefined,
                bundleIndicator: props.bundleIndicator,
                producerCode: submissionVM.producerCodeOfRecord_ML.code?.value,
                zip: submissionVM.baseData.value.policyAddress.postalCode,
                pfm: submissionVM.baseData.value.pfmLevel_ML,
                productType: getCoveragePackageLevel(submissionVM),
                quoteID: props.quoteID,
                isCompRater: props.isCompRater 
            };

            const category = (eventName === 'Quote Step Reached') ? 'Quote Page' : 'Issuance Page';

            window.analytics.page(category, props.step, pageProps);

            if (!isQnB) {
                try {
                    window.analytics.identify(user.userName_ML, {
                        name: user.displayName,
                        email: user.email,
                        producercode: user.primaryProducerCode_ML?.code,
                        userType: user.userTypeName_ML,
                        pc_username: user.userName_ML,
                        groupName: user.affiliatedGroup_ML?.groupName,
                        login : user.loginID,
                        IAPortalId: user.portalId,
                        pol_state: props.pol_state,
                        lob: props.lob,
                        isCompRater: props.isCompRater ,
                        quoteID: props.quoteID,
                        bundleIndicator: props.bundleIndicator,
                        app_page: props.step,
                        Agent_Segment: user.primaryProducerCode_ML?.producerLevel,
                        Transaction_Type: eventName,
                        PolicyNumber: undefined,
                        PolicyNumbers: undefined,
                        lobs: undefined,
                        pol_states: undefined
                    });
                } catch (e) {
                    console.error(`Segment error calling identify API: ${e.message}`);
                }
            }
        }

        sessionStorage.setItem('segmentProps', JSON.stringify(props));
    } catch (e) {
        console.error(`Segment Error in PUP Track Event: ${e.message}`);
    }
};

export default PUMBTrackEvent ;